export default function ChantiersConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('chantiers');
}

ChantiersConfiguration.$inject = ['$translatePartialLoaderProvider'];
